var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsightsSelectedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0V0Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-insights-selected-icon)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.002 16H17.002V13H13.002V16Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00195 9H17.002V8H5.00195V9Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.002 9.5C18.002 9.776 17.778 10 17.502 10H4.50195C4.22595 10 4.00195 9.776 4.00195 9.5V7.5C4.00195 7.224 4.22595 7 4.50195 7H17.502C17.778 7 18.002 7.224 18.002 7.5V9.5ZM18.002 16.5C18.002 16.776 17.778 17 17.502 17H12.502C12.226 17 12.002 16.776 12.002 16.5V12.5C12.002 12.224 12.226 12 12.502 12H17.502C17.778 12 18.002 12.224 18.002 12.5V16.5ZM17.502 19H12.502C12.226 19 12.002 18.776 12.002 18.5C12.002 18.224 12.226 18 12.502 18H17.502C17.778 18 18.002 18.224 18.002 18.5C18.002 18.776 17.778 19 17.502 19ZM9.50195 13H4.50195C4.22595 13 4.00195 12.776 4.00195 12.5C4.00195 12.224 4.22595 12 4.50195 12H9.50195C9.77795 12 10.002 12.224 10.002 12.5C10.002 12.776 9.77795 13 9.50195 13ZM9.50195 15H4.50195C4.22595 15 4.00195 14.776 4.00195 14.5C4.00195 14.224 4.22595 14 4.50195 14H9.50195C9.77795 14 10.002 14.224 10.002 14.5C10.002 14.776 9.77795 15 9.50195 15ZM9.50195 17H4.50195C4.22595 17 4.00195 16.776 4.00195 16.5C4.00195 16.224 4.22595 16 4.50195 16H9.50195C9.77795 16 10.002 16.224 10.002 16.5C10.002 16.776 9.77795 17 9.50195 17ZM9.50195 19H4.50195C4.22595 19 4.00195 18.776 4.00195 18.5C4.00195 18.224 4.22595 18 4.50195 18H9.50195C9.77795 18 10.002 18.224 10.002 18.5C10.002 18.776 9.77795 19 9.50195 19ZM22.502 2H3.50195C3.22595 2 3.00195 2.224 3.00195 2.5C3.00195 2.776 3.22595 3 3.50195 3H22.002V20C22.002 20.5515 21.5535 21 21.002 21V4.5C21.002 4.224 20.778 4 20.502 4H1.50195C1.22595 4 1.00195 4.224 1.00195 4.5V20C1.00195 21.103 1.89895 22 3.00195 22H21.002C22.105 22 23.002 21.103 23.002 20V2.5C23.002 2.224 22.778 2 22.502 2Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-insights-selected-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightsSelectedIcon);
export default __webpack_public_path__ + "static/media/insights-selected-icon.60ab413a3b55139fecd680942c96d160.svg";
export { ForwardRef as ReactComponent };